import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-pagination-page-select',
  templateUrl: './pagination-page-select.component.html',
  styleUrls: ['./pagination-page-select.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginationPageSelectComponent implements OnInit {
  @Input() page: number;
  @Input() totalItems: number;
  @Input() pageSize: number;
  @Output() pageChange = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  get pages(): number[] {
    const pages = Math.ceil((this.totalItems || 1) / this.pageSize);
    return Array.from({ length: pages }, (_, i) => i + 1);
  }

  onChange(page: string) {
    this.pageChange.emit(Number(page));
  }
}
